import { ReactNode } from "react";
import calendar from "./assets/calendar 1 .jpg";
import flyer from "./assets/Flyers.webp";
import folder from "./assets/carpeta.jpg";
import businessCard from "./assets/business-card.jpg";
import receipt from "./assets/Recibos.jpg";
import invoice from "./assets/invoice.jpg";
import brochure from "./assets/Brochure-Mockup.jpg";
import poster from "./assets/Poster.jpg";
import proforma from "./assets/ProForma-mockup.jpg";
import letterhead from "./assets/letterhead-mockup.jpg";
import diptych from "./assets/bifold-architecture.jpg";

export type MaterialsId = "bond" | "linen" | "opaline" | "sulfite" | "satin";
export type QuantityId = "1" | "50" | "100" | "250" | "300" | "500";
export type PrintId = "oneSide" | "doubleSided";
export type ProductId = 
 "business-cards"
 | "posters"
 | "calendars"
 | "folders"
 | "invoices"
 | "receipts"
 | "brochures"
 | "proforma"
 | "letterhead"
 | "diptych" ;

export type FinishingId =
  | "laminating"
  | "uvCoating"
  | "matte"
  | "glossy"
  | "roundCornering"
  | "drilling"
  | "fullColor"
  | "oneColor"
  | "twoColor";

export type DimentionsId = "3.5x2"
 | "8.5x5.5"
 | "2x2"
 | "5.5x8.5"
 | "8.5x7.25"
 | "4.25x5.5"
 | "8.5x11"
 | "11x17"
 | "12x18"
 | "17x22"
 | "18x24"
 | "24x36"
 | "custom";

export type Material = {
  id: MaterialsId;
  label: string;
  image: string | null;
};
export type Printing = {
  id: PrintId;
  label: string;
  image: string | null;
};
export type Finish = {
  id: FinishingId;
  label: string;
  image: string | null;
};

export type Dimention = {
  id: DimentionsId;
  label: string;
  image: string | null;
};

export type Products = Record<ProductId, Product>;
export interface Product {
  id: ProductId;
  label: string;
  finishing: Record<FinishingId, Finish>[];
  dimentions: DimentionsId[];
  materials: MaterialsId[];
  icon: ReactNode;
  img: string;
  minQuantity: QuantityId;
  printing: PrintId[];
}

// finishing
export const finishing = {
  laminating: {
    id: "laminating",
    label: "Laminado",
    image: null,
  },
  uvCoating: {
    id: "uvCoating",
    label: "Barnizado UV",
    image: null,
  },
  glossy: {
    id: "glossy",
    label: "Brillante",
    image: null,
  },
  roundCornering: {
    id: "roundCornering",
    label: "Bordes Redondeados",
    image: null,
  },
  drilling: {
    id: "drilling",
    label: "Encuadernado",
    image: null,
  },
  matte: {
    id: "matte",
    label: "Mate",
    image: null,
  },
  fullColor: {
    id: "fullColor",
    label: "Full  Color",
    image: null,
  },
  oneColor: {
    id: "oneColor",
    label: "Un color",
    image: null,
  },
  twoColor: {
    id: "twoColor",
    label: "2 Colores",
    image: null,
  },
};

//dimentions
export const dimentions = {
  "3.5x2": {
    id: "3.5x2",
    label: "3.5 x 2 Pulgadas",
    image: null,
  },
  "2x2": {
    id: "2x2",
    label: "2 x 2 Pulgadas",
    image: null,
  },
  "4.25x5.5": {
    id: "4.25x5.5",
    label: "4.25 x 5.5 Pulgadas",
    image: null,
  },
  "5.25x8.25": {
    id: "5.25x8.25",
    label: "5.25 x 8.25 Pulgadas",
    image: null,
  },
  "8.5x11": {
    id: "8.5x11",
    label: "8.5 x 11 Pulgadas",
    image: null,
  },
  "11x17": {
    id: "11x17",
    label: "11 x 17 Pulgadas",
    image: null,
  },
  "17x22": {
    id: "17x22",
    label: "17 x 22 Pulgadas",
    image: null,
  },
  "18x24": {
    id: "18x24",
    label: "18 x 24 Pulgadas",
    image: null,
  },
  "24x36": {
    id: "24x36",
    label: "24 x 36 Pulgadas",
    image: null,
  },
  custom: {
    id: "custom",
    label: "Personalizado",
    image: null,
  },
};

// materials
export const materials = {
  bond: {
    id: "bond",
    label: "Papel Bond",
    image: null,
  },
  linen: {
    id: "linen",
    label: "Papel Lino",
    image: null,
  },
  opaline: {
    id: "opaline",
    label: "Papel Opalina",
    image: null,
  },
  sulfite: {
    id: "sulfite",
    label: "Papel Sulfito",
    image: null,
  },
  satin: {
    id: "satin",
    label: "Papel Satinado",
    image: null,
  },
};

//printing
export const printing = {
  oneSide: {
    id: "oneSide",
    label: 'Una Cara',
    img: null,
  },
  doubleSided: {
    id: "doubleSided",
    label: 'Dos Caras',
    img: null,
  }
}

//products
export const products: Products = {
  "business-cards": {
    id: "business-cards",
    label: "Tarjetas de Presentación",
    finishing: ["laminating", "roundCornering"],
    dimentions: ["3.5x2", "2x2"],
    materials: ["opaline", "sulfite", "linen"],
    minQuantity: "100",
    printing: ["oneSide", "doubleSided"],
    img: businessCard,
  },
  flyers: {
    id: "flyers",
    label: "Volantes",
    finishing: ["fullColor", "oneColor", "twoColor"],
    dimentions: ["5.25x8.25", "custom"],
    materials: ["satin", "bond"],
    minQuantity: "250",
    printing: ["oneSide", "doubleSided"],
    img: flyer,
  }, 
  invoices: {
    id: "invoices",
    label: "Facturas",
    finishing: ["fullColor", "oneColor", "twoColor"],
    dimentions: ["8.5x5.5", "8.5x11"],
    materials: ["bond"],
    minQuantity: "250",
    printing: ["oneSide"],
    img: invoice,
  },
  receipts: {
    id: "receipts",
    label: "Recibos",
    finishing: ["fullColor", "oneColor", "twoColor"],
    dimentions: ["8.5x5.5", "8.5x11"],
    materials: ["bond"],
    minQuantity: "250",
    printing: ["oneSide"],
    img: receipt,
  },
  folders: {
    id: "folders",
    label: "Carpetas",
    finishing: ["laminating", "matte", "uvCoating"],
    dimentions: ["11x17", "18x24", "24x36"],
    materials: ["opaline", "sulfite", "linen"],
    minQuantity: "500",
    printing: ["oneSide", "doubleSided"],
    img: folder,
  },
  calendars: {
    id: "calendars",
    label: "Calendar",
    finishing: ["uvCoating"],
    dimentions: ["8.5x5.5", "8.5x11", "11x17"],
    materials: ["opaline", "sulfite", "linen"],
    minQuantity: "500",
    printing: ["oneSide", "doubleSided"],
    img: calendar,
  },
  brochures: {
    id: "brochures",
    label: "Brochures",
    finishing: ["fullColor", "uvCoating"],
    dimentions: ["8.5x11"],
    materials: ["bond", "satin"],
    printing: ["doubleSided"],
    minQuantity: '1',
    img: brochure,

  },
  posters: {
    id: "posters",
    label: "Afiches",
    finishing: ["oneColor", "twoColor", "fullColor", "uvCoating"],
    dimentions: ["11x17", "12x18" , "17x22", "18x24" ],
    materials: ["sulfite", "satin"],
    minQuantity: '1',
    printing: ["oneSide"],
    img: poster,
  },
  proforma: {
    id: "proforma",
    label: "Proforma",
    finishing: ["oneColor", "twoColor", "fullColor", "uvCoating"],
    dimentions: ["11x17", "12x18" , "17x22", "18x24" ],
    materials: ["bond"],
    minQuantity: '1',
    printing: ["oneSide", "doubleSided"],
    img: proforma,
  },
  letterhead: {
    id: "letterhead",
    label: "Hoja Membretada",
    finishing: ["oneColor", "twoColor", "fullColor"],
    dimentions: ["8.5x11", "8.5x7.25 "],
    materials: ["bond"],
    minQuantity: '1',
    printing: ["oneSide"],
    img: letterhead,
  }, 
  diptych: {
    id: "diptych",
    label: "Díptico",
    finishing: [ "fullColor", "uvCoating"],
    dimentions: ["5.5x8.5"],
    materials: ["satin"],
    minQuantity: '1',
    printing: [ "doubleSided"],
    img: diptych,
  },
};
